"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var event_base_1 = require("./event-base");
var event_1 = require("./model/event");
var operators_1 = require("rxjs/operators");
var EventBaseImpl = /** @class */ (function (_super) {
    __extends(EventBaseImpl, _super);
    function EventBaseImpl() {
        var _this = _super.call(this) || this;
        _this._events = new Subject_1.Subject();
        return _this;
    }
    EventBaseImpl.checkKeyIsProvided = function (key, errorMessage) {
        if (!key) {
            throw new TypeError(errorMessage);
        }
    };
    EventBaseImpl.routeMatches = function (routing, filterRoute) {
        return routing === filterRoute;
    };
    EventBaseImpl.getInstance = function () {
        if (!this._instance) {
            this._instance = new EventBaseImpl();
        }
        return this._instance;
    };
    EventBaseImpl.prototype.publish = function (routingKey, data) {
        var errorMessage = 'Invalid routingKey was provided. Should be provided not empty value';
        EventBaseImpl.checkKeyIsProvided(routingKey, errorMessage);
        this._events.next(event_1.Event.create(routingKey, data));
    };
    EventBaseImpl.prototype.listen = function (routingKey) {
        var errorMessage = 'Invalid routingKey was provided. Should be provided not empty value';
        EventBaseImpl.checkKeyIsProvided(routingKey, errorMessage);
        return this._events.pipe(operators_1.filter(function (event) { return EventBaseImpl.routeMatches(routingKey, event.routingKey); }));
    };
    return EventBaseImpl;
}(event_base_1.EventBase));
exports.EventBaseImpl = EventBaseImpl;
//# sourceMappingURL=event-base-impl.js.map